<template>
	<div>
		<!--工具条-->
		<el-col :span="24" class="toolbar uptool" style="padding-bottom: 0px;">
			<el-form :inline="true">
				<el-form-item>
					<el-input v-model="inputWhat" placeholder="请输入姓名或手机号" prefix-icon="el-icon-search" size="small"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" size="small" icon="el-icon-search" @click="find">搜索</el-button>
				</el-form-item>
				<el-form-item style="float: right;">
					<el-button type="primary" plain size="small" @click="Refresh">刷新</el-button>
				</el-form-item>
				<!--<el-form-item style="float: right;">
					<el-button type="primary" plain size="small" @click="Daochu">导出</el-button>
				</el-form-item>-->
			</el-form>
		</el-col>
		
		<el-table id="seedTable" :data="List" ref="table" border v-loading="listloading" style="width: 99.9%" :max-height="maxHeight" @filter-change="Filterfind">
		    <el-table-column label="姓名" prop="name" width="80" fixed></el-table-column>
		    <el-table-column label="性别" width="50">
		    	<template slot-scope="scope">
		    		<span>{{scope.row.gender == 1 ? '男':scope.row.gender == 2 ? '女':'未知'}}</span>
				</template>
		    </el-table-column>
		    <el-table-column label="手机" prop="phone" width="110"></el-table-column>
		    <el-table-column label="年龄" prop="age" width="70">
		    	<template slot-scope="scope">
		    		<span>{{scope.row.age}} 岁</span>
				</template>
		    </el-table-column>
		    <el-table-column label="身高" prop="height" width="70">
		    	<template slot-scope="scope">
		    		<span>{{scope.row.height}} cm</span>
				</template>
		    </el-table-column>
		    <el-table-column label="体重" prop="weight" width="70">
		    	<template slot-scope="scope">
		    		<span>{{scope.row.weight}} kg</span>
				</template>
		    </el-table-column>
		    <el-table-column label="原工作" prop="last_job"></el-table-column>
		    <el-table-column label="现工作" prop="current_job"></el-table-column>
		    <el-table-column label="常住地" width='200'>
		    	<template slot-scope="scope">
					<span>{{scope.row.addr[0]}},{{scope.row.addr[1]}},{{scope.row.addr[2]}}</span>
				</template>
		    </el-table-column>
		    <el-table-column label="病种" prop="Q1" :formatter="Q1Format" width="230"></el-table-column>
		    <el-table-column label="手功能等级">
		    	<template slot-scope="scope">
					<span>{{scope.row.Q2}} 级</span>
				</template>
		    </el-table-column>
		    <el-table-column label="体位性低血压" prop="Q3" :formatter="tfFormat" width="70"></el-table-column>
		    <el-table-column label="站立训练频率" width="70">
		    	<template slot-scope="scope">
		    		<span v-if="scope.row.Q4 == 1">无</span>
		    		<span v-if="scope.row.Q4 == 2">每天</span>
		    		<span v-if="scope.row.Q4 == 3">偶尔</span>
				</template>
		    </el-table-column>
		    <el-table-column label="脚踝外翻情况" prop="Q5" :formatter="tfFormat" width="70"></el-table-column>
		    <el-table-column label="体验过邦邦车" prop="Q6" :formatter="tfFormat" width="70"></el-table-column>
		    <el-table-column label="能独立出行、旅游" prop="Q7" :formatter="tfFormat"></el-table-column>
		    <el-table-column label="居家环境改造" prop="Q8" :formatter="tfFormat" width="70"></el-table-column>
		    <el-table-column label="认识伤友的人数" prop="Q9">
		    	<template slot-scope="scope">
		    		<span v-if="scope.row.Q9 == 1">20人以下</span>
		    		<span v-if="scope.row.Q9 == 2">21-50人</span>
		    		<span v-if="scope.row.Q9 == 3">50人以上</span>
				</template>
		    </el-table-column>
		    <el-table-column label="已加入组织" prop="Q10" width='120'>
		    	<template slot-scope="scope">
			    	<span v-if="scope.row.Q10.length > 0">
			    		<span v-for="item in scope.row.Q10">
							<p v-if="item == 1" style="margin: 0;">希望之家 </p>
							<p v-if="item == 2" style="margin: 0;">伤友会 </p>
							<p v-if="item == 3" style="margin: 0;">康复小组 </p>
							<p v-if="item != 1 && item != 2 && item != 3" style="margin: 0;">{{item}}</p>
						</span>
			    	</span>
		    	</template>
		    </el-table-column>
		    <el-table-column label="组织过伤友聚会或活动" prop="Q11" :formatter="tfFormat" width="100"></el-table-column>
			<el-table-column fixed="right" label="提交时间" prop="created_at" width="180" :formatter="dateFormat"></el-table-column>
  		</el-table>
  		
  		<!--工具条-->
  		<el-col :span="24" class="toolbar downtool">
			<el-pagination layout="total,prev, pager, next,jumper" @current-change="handleCurrentChange" :page-size="Pagesize" :current-page="Curpage" :total="total" style="float:right;">
			</el-pagination>
		</el-col>
	</div>
</template>

<script>
	import {GetCandidate} from '../api/api';
	import FileSaver from 'file-saver'
	import XLSX from 'xlsx'
	
	export default {
		data(){
			return {
				token:"",
				maxHeight:600,
				listloading:false,
				total:1,
				Curpage:1,
				Pagesize:50,
				List:[],
				Findform:"",
				inputWhat:"",
				typeChoose:[],
				lastData:[]
			}
		},
		methods:{
			Daochu(){
				this.exportExcel()
			},
			exportExcel () {
                /* generate workbook object from table */
                let wb = XLSX.utils.table_to_book(document.querySelector('#seedTable'));
                /* get binary string as output */
                let wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' });
                
                try {
                    FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), '种子用户信息登记表.xlsx');
                } catch (e)
                {
                    if (typeof console !== 'undefined')
                        console.log(e, wbout)
                }
                return wbout
			},
			handleCurrentChange(val){
				this.Curpage = val
				this.find()
			},
			Refresh(){
//				console.log(this)
				this.inputWhat = ""
				this.$refs.table.clearFilter()
				this.typeChoose = []
				this.GetList(GetCandidate,{page:this.Curpage,perPage:this.Pagesize,token:this.token})
			},
			Filterfind(filters){
				var that =  this
				that.typeChoose = filters.type
				that.find()
			},
			find(){
				var that =  this
				if(that.inputWhat){
					var flag = that.isNumber(that.inputWhat)
					if(flag){
						if(that.typeChoose.length > 0){
							that.lastData = [{AND:{"phone":"~" + that.inputWhat,"type":that.typeChoose}}]
						}else{
							that.lastData = [{AND:{"phone":"~" + that.inputWhat}}]
						}
					}else{
						if(that.typeChoose.length > 0){
							that.lastData = [{AND:{"name":"~" + that.inputWhat,"type":that.typeChoose}}]
						}else{
							that.lastData = [{AND:{"name":"~" + that.inputWhat}}]
						}
					}
//					console.log(that.lastData)
					that.lastData2 = JSON.stringify(that.lastData)
					this.GetList(GetCandidate,{page:this.Curpage,perPage:this.Pagesize,token:this.token,q:that.lastData2})
				}else if(!that.inputWhat && that.typeChoose.length > 0){
					that.lastData = [{AND:{"type":that.typeChoose}}]
					that.lastData2 = JSON.stringify(that.lastData)
//					console.log(that.lastData)
					this.GetList(GetCandidate,{page:this.Curpage,perPage:this.Pagesize,token:this.token,q:that.lastData2})
				}else{
					this.GetList(GetCandidate,{page:this.Curpage,perPage:this.Pagesize,token:this.token})
				}
				
			},
			Q1Format(row,column){
				if(row[column.property] == 2){
					return "偏瘫"
				}else if(row[column.property] == 3){
					return "小儿麻痹"
				}else if(typeof row[column.property] == 'string'){
					if(row[column.property] == ""){
						return '无'
					}else{
						return row[column.property]
					}
				}else{
					var arr = row[column.property].options
					var len = arr.length
					for(var i = 0; i < len; i++){
				        for(var j = 0; i < len - 1 - i; i++){
				            if(arr[j] > arr[j+1]) {//相邻元素两两对比
				                var temp = arr[j+1];//元素交换
				                arr[j+1] = arr[j];
				                arr[j] = temp;
				            }
				        }
				    }
					
					var str = '脊柱损伤:'
					for(var item in arr){
						if(arr[item] == 17){str += ' C2~C3'}
						if(arr[item] == 18){str += ' C3~C4'}
						if(arr[item] == 19){str += ' C4~C5'}
						if(arr[item] == 20){str += ' C5~C6'}
						if(arr[item] == 21){str += ' C6~C7'}
						if(arr[item] == 22){str += ' C7~C8'}
						if(arr[item] == 33){str += ' T1~T2'}
						if(arr[item] == 34){str += ' T2~T3'}
						if(arr[item] == 35){str += ' T3~T4'}
						if(arr[item] == 36){str += ' T4~T5'}
						if(arr[item] == 37){str += ' T5~T6'}
						if(arr[item] == 38){str += ' T6~T7'}
						if(arr[item] == 39){str += ' T7~T8'}
						if(arr[item] == 40){str += ' T8~T9'}
						if(arr[item] == 41){str += ' T9~T1'}
						if(arr[item] == 42){str += ' T10~T11'}
						if(arr[item] == 43){str += ' T11~T12'}
						if(arr[item] == 49){str += ' L1~L2'}
						if(arr[item] == 50){str += ' L2~L3'}
						if(arr[item] == 51){str += ' L3~L4'}
						if(arr[item] == 52){str += ' L4~L5'}
						if(arr[item] == 65){str += ' S1~S2'}
						if(arr[item] == 66){str += ' S2~S3'}
						if(arr[item] == 67){str += ' S3~S4'}
						if(arr[item] == 68){str += ' S4~S5'}
					}
					return str
				}
			},
			tfFormat(row,column){
				if(row[column.property] == 1){
					return '是'
				}else if(row[column.property] == 0){
					return '否'
				}else{
					return '未知'
				}
			},
			isNumber(val) {
			    var regPos = /^\d+(\.\d+)?$/; //非负浮点数
			    var regNeg = /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/; //负浮点数
			    if(regPos.test(val) || regNeg.test(val)) {
			        return true;
			    } else {
			        return false;
			    }
			}
			
		},
		created(){
			this.token = sessionStorage.getItem("BBRtoken");
			this.GetList(GetCandidate,{page:this.Curpage,perPage:this.Pagesize,token:this.token})
		},
		mounted(){
			this.$nextTick(function(){
				this.Gethigh()
			})
		}
	}

</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// SeedCandidate.vue?72a44ceb